import { render, staticRenderFns } from "./imprRelationTagPop.vue?vue&type=template&id=716de993&scoped=true"
import script from "./imprRelationTagPop.vue?vue&type=script&lang=js"
export * from "./imprRelationTagPop.vue?vue&type=script&lang=js"
import style0 from "./imprRelationTagPop.vue?vue&type=style&index=0&id=716de993&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716de993",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716de993')) {
      api.createRecord('716de993', component.options)
    } else {
      api.reload('716de993', component.options)
    }
    module.hot.accept("./imprRelationTagPop.vue?vue&type=template&id=716de993&scoped=true", function () {
      api.rerender('716de993', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprRelationTagPop.vue"
export default component.exports